import React from "react";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import { navigate } from "gatsby";

const ThemeBtn = ({ label, link }: { label: string; link: string }) => {
	const handleClick = () => {
		window.open(link);
	};
	return (
		<Button
			component="a"
			href={link}
			target="_blank"
			rel="noopener noreferrer"
			disableElevation
			variant="contained"
			endIcon={<EastIcon />}
			sx={{
			borderRadius: 20,
						px:{xs:2,md:3},
						py: {xs:1,md:1.5},
						fontWeight: 600,
						textTransform: "none",
						background:
							"linear-gradient(181deg, rgba(156, 44, 252, 0.3) 0%, rgba(147, 0, 255, 1) 100%)",
			}}
		>
			{label}
		</Button>
	);
};

export default ThemeBtn;
